import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/goncharenko.jpeg";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import { Link } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";
import React from "react";

export const PersonGoncharenko = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}>Гончаренко Татьяна Андреевна</MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Доктор технических наук, профессор
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={12} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=57204204504'}>
                            <MyText><LinkOutlined /> Scopus (h=15, цит. 373)</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://orcid.org/0000-0003-2577-6916'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://www.webofscience.com/wos/author/record/ABG-3448-2021'}>
                            <MyText><LinkOutlined /> Web of Science (ABG-3448-2021)</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://scholar.google.com.ua/citations?user=QZgiQ34AAAAJ'}>
                            <MyText><LinkOutlined /> Google Scholar (h=21, цит. 1355)</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>Основное место работы, должность</MyText>
                    <MyText>Киевский национальный университет строительства и архитектуры, заведующая кафедрой информационных технологий. Опыт — более 12 лет.</MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте</MyText>
                <MyText size={"small"} italic>Ведущий научный сотрудник</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка методологии, моделей, методов и информационной технологии для автоматизации сложных объектно-пространственных систем;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка структур моделей данных для моделирования городской среды на основе интеграции BIM и GIS в «Smart City»;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка сервис-ориентированной архитектуры информационной системы органов исполнительной власти;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Внедрение программного модуля для создания цифровых двойников городских объектов.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Опыт информационного моделирования и автоматизации бизнес-процессов строительных проектов. Разработка и сопровождение сложных программных комплексов в строительных организациях и органах исполнительной власти.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR24993128 «ИАС трансграничных водных ресурсов» (2024-2026), исполнитель.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Erasmus+ KA2 «GameHub» № 56128-EPP-1-2015-1-ES-EPPKA2-CBHE-JP (2015-2018).
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - «Методология определения тональности и классификации мультимодального контента» (2025-2027), руководитель.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - «Интеграция информационных технологий для создания цифровых двойников городских объектов».
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Награды:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - 2024 — Грамота Министерства науки и образования Украины.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - 2024 — Почётная грамота Академии строительства Украины.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Публикации:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    1. Kuchansky, Andrashko, Biloshchytskyi, Danchenko, Ilarionov, Vatskel, Honcharenko. Evaluation of educational environment subjects' performance using M-simplexes volumes. Eastern-European Journal of Enterprise Technologies, 2018. [Scopus Q3]
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    2. Berezutskyi, Honcharenko et al. Methodological Approach for Choosing Type of IT Projects Management. IEEE SIST, 2024. [Scopus]
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    3. Honcharenko, Akselrod, Shpakov, Khomenko. Information system based on multi-value classification of fully connected neural network. IAES Int. J. of AI, 2023. [Scopus Q2]
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    4. Ryzhakova, Malykhina, Homenko, Honcharenko. Construction Project Management with Digital Twin Information System. IJETAE, 2022. [Scopus]
                </MyText>
            </Flex>
        </Flex>
    );
};
